const onboardingTemplate = {
  customise_onboarding: "Incorporación personalizada",
  onboarding_templates: "Plantillas de incorporación",
  onboarding_template_groups: "Grupos de documentos",
  documents_lower: "documentos",
  document_groups_lower: "grupos de documentos",
  mandatory: "obligatorios",
  add_expiry: "Vencimiento",
  add_template: "Agregar plantilla",
  add_group: "Agregar grupo",
  documents: "Documentos",
  document_groups: "Grupos de documentos",
  document_name: "Nombre del documento",
  is_mandatory: "Obligatorio",
  add_document: "Agregar documento",
  add_document_group_title: "Agregar grupo de documentos",
  edit_document_group_title: "Editar grupo de documentos",
  document_group_dialog_subtitle:
    "Agrupa los documentos que quieres solicitar juntos y define cuáles son obligatorios o caducan.",
  add_onboarding_template_title: "Agregar plantilla de incorporación",
  edit_onboarding_template_title: "Editar plantilla de incorporación",
  onboarding_template_dialog_subtitle:
    "Elige los grupos de documentos que se pedirán a un proveedor en esta plantilla.",
  select_document_groups: "Seleccionar grupos de documentos",
  select_document_groups_dialog_subtitle:
    "Elige los grupos de documentos que se incluirán en esta plantilla.",
  select: "Seleccionar",
  all_document_groups_selected:
    "Todos los grupos de documentos disponibles ya están seleccionados.",
  no_groups_selected_yet: "Aún no hay grupos de documentos seleccionados.",
  group_name: "Nombre del grupo",
  template_name: "Nombre de la plantilla",
  description_optional: "Descripción (opcional)",
  enter_description: "Ingresar descripción",
  search_to_add_document_groups: "Buscar para agregar grupos de documentos",
  mandatory_documents_count: "{{count}} documentos obligatorios",
  no_document_groups_yet:
    "Aún no hay grupos de documentos. Crea uno primero en la pestaña Grupos de documentos.",
  save_group: "Guardar grupo",
  save_template: "Guardar plantilla",
  no_templates_found: "No se encontraron plantillas de incorporación",
  no_groups_found: "No se encontraron grupos de documentos",
  template_created_successfully: "Plantilla de incorporación creada correctamente",
  template_updated_successfully: "Plantilla de incorporación actualizada correctamente",
  template_deleted_successfully: "Plantilla de incorporación eliminada correctamente",
  group_created_successfully: "Grupo de documentos creado correctamente",
  group_updated_successfully: "Grupo de documentos actualizado correctamente",
  group_deleted_successfully: "Grupo de documentos eliminado correctamente",
  delete_template_title:
    "¿Está seguro de que desea eliminar la plantilla de incorporación?",
  delete_template_description:
    "Una vez eliminada una plantilla de incorporación, también se eliminará de todos los proveedores que la utilizan",
  delete_group_title:
    "¿Está seguro de que desea eliminar el grupo de documentos?",
  delete_group_description:
    "Una vez eliminada una plantilla de incorporación, también se eliminará de todas las plantillas de incorporación que la mencionan",
  remove_group_from_template_title:
    "¿Está seguro de que desea quitar el grupo de documentos?",
  remove_group_from_template_description:
    "Este grupo de documentos se quitará de esta plantilla de incorporación. El grupo en sí no se eliminará.",
  name_required: "El nombre es obligatorio",
  at_least_one_document_required: "Se requiere al menos un documento",
  at_least_one_group_required: "Se requiere al menos un grupo",
  something_went_wrong: "Algo salió mal",
};

export default onboardingTemplate;
